import { render, staticRenderFns } from "./ForgottenPasswordContainer.vue?vue&type=template&id=518312e0&"
import script from "./ForgottenPasswordContainer.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports